import { FetchError } from "@medusajs/js-sdk"
import { QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query"
import { backendUrl } from "../../lib/client"
import { queryKeysFactory } from "../../lib/query-key-factory"

type AdminRoleResponse = {
  role: "super_admin" | "merchant_admin" | null
}

const AUTH_ROLE_QUERY_KEY = "auth-role" as const
const authRoleQueryKeys = {
  ...queryKeysFactory(AUTH_ROLE_QUERY_KEY),
  detail: () => [AUTH_ROLE_QUERY_KEY],
}

export const useAdminRole = (
  options?: UseQueryOptions<
    AdminRoleResponse,
    FetchError,
    AdminRoleResponse,
    QueryKey
  >
) => {
  const fetchRole = async () => {
    const base = backendUrl.replace(/\/$/, "")
    const res = await fetch(`${base}/admin/auth/role`, {
      method: "GET",
      credentials: "include",
      headers: {
        "content-type": "application/json",
      },
    })

    if (res.status === 401 || res.status === 403) {
      return { role: null }
    }

    if (!res.ok) {
      const text = await res.text().catch(() => "")
      throw new Error(text || "Failed to fetch admin role")
    }

    return (await res.json()) as AdminRoleResponse
  }

  return useQuery({
    queryKey: authRoleQueryKeys.detail(),
    queryFn: fetchRole,
    ...options,
  })
}
